import { scheduler } from './utils/scheduler';
import { ResizeObservation } from './ResizeObservation';
import { ResizeObserverDetail } from './ResizeObserverDetail';
import { hasActiveObservations } from './algorithms/hasActiveObservations';
import { hasSkippedObservations } from './algorithms/hasSkippedObservations';
import { deliverResizeLoopError } from './algorithms/deliverResizeLoopError';
import { broadcastActiveObservations } from './algorithms/broadcastActiveObservations';
import { gatherActiveObservationsAtDepth } from './algorithms/gatherActiveObservationsAtDepth';
const resizeObservers = [];
const observerMap = new Map();
let watching = 0;
const updateCount = (n) => {
    !watching && n > 0 && scheduler.start();
    watching += n;
    !watching && scheduler.stop();
};
const getObservationIndex = (observationTargets, target) => {
    for (let i = 0; i < observationTargets.length; i += 1) {
        if (observationTargets[i].target === target) {
            return i;
        }
    }
    return -1;
};
const process = () => {
    let depth = 0;
    gatherActiveObservationsAtDepth(depth);
    while (hasActiveObservations()) {
        depth = broadcastActiveObservations();
        gatherActiveObservationsAtDepth(depth);
    }
    if (hasSkippedObservations()) {
        deliverResizeLoopError();
    }
    return depth > 0;
};
class ResizeObserverController {
    static connect(resizeObserver, callback) {
        const detail = new ResizeObserverDetail(resizeObserver, callback);
        resizeObservers.push(detail);
        observerMap.set(resizeObserver, detail);
    }
    static observe(resizeObserver, target, options) {
        if (observerMap.has(resizeObserver)) {
            const detail = observerMap.get(resizeObserver);
            if (getObservationIndex(detail.observationTargets, target) < 0) {
                detail.observationTargets.push(new ResizeObservation(target, options && options.box));
                updateCount(1);
                scheduler.schedule();
            }
        }
    }
    static unobserve(resizeObserver, target) {
        if (observerMap.has(resizeObserver)) {
            const detail = observerMap.get(resizeObserver);
            const index = getObservationIndex(detail.observationTargets, target);
            if (index >= 0) {
                detail.observationTargets.splice(index, 1);
                updateCount(-1);
            }
        }
    }
    static disconnect(resizeObserver) {
        if (observerMap.has(resizeObserver)) {
            const detail = observerMap.get(resizeObserver);
            resizeObservers.splice(resizeObservers.indexOf(detail), 1);
            observerMap.delete(resizeObserver);
            updateCount(-detail.observationTargets.length);
        }
    }
}
export { ResizeObserverController, resizeObservers, process };
